import { triplePointCampaignId } from 'constants/siteTakeover/societyTriplePointsTakeover'

export function getLoyaltyBonusPointsCampaignType({ bonusPoints, basePoints }: {
  basePoints: number,
  bonusPoints: number,
}): App.LoyaltyBonusPointsCampaignType | undefined {
  if (!bonusPoints) return
  switch (bonusPoints / basePoints) {
    case 1:
      return 'double'
    case 2:
      return 'triple'
    default:
      return 'static'
  }
}

export function determineOfferLoyaltyBonusPointsCampaignType(
  offer: App.Offer | App.HotelOffer | App.HotelOfferSummary | App.Tours.TourV2Offer | App.Tours.TourV2OfferSummary,
): App.LoyaltyBonusPointsCampaignType | undefined {
  if (offer.campaignTags.includes(triplePointCampaignId)) return 'triple'
}

function determineLoyaltyBonusPointsCampaignType(calculation: Omit<App.LoyaltyPointsEarnCalculation, 'request'>): App.LoyaltyBonusPointsCampaignType | undefined
function determineLoyaltyBonusPointsCampaignType(calculation: App.LoyaltyPointsEarnCalculation): App.LoyaltyBonusPointsCampaignType | undefined {
  return getLoyaltyBonusPointsCampaignType({
    basePoints: calculation.basePoints,
    bonusPoints: calculation.bonusPoints,
  })
}

export default determineLoyaltyBonusPointsCampaignType
